import { Timer, Timers } from '../types/timers'
import { useDatabase } from '../composables/database'
import { TimersRows } from 'app/types/database'
import { jsDateToSqliteDate } from './helpers'

type TimersModelReturn = {
  getAll: () => Promise<TimersRows | void | null>
  /**
   * Returns today's timers.
   * Return is result from JSON.parse. Dates have not been converted to date objects.
   */
  getTimers: () => Promise<Timers | void>
  /**
   * Returns array of all timers on device, most recent first in index.
   * Return is result from JSON.parse. Dates have not been converted to date objects.
   */
  getAllTimers: () => Promise<Timers[] | void>
  /**
   * Returns all previous days timers on device.
   * Return is result from JSON.parse. Dates have not been converted to date objects.
   */
  getAllPreviousTimers: () => Promise<Timers[] | void>
  /**
   * Writes timers to database. Takes Date object.
   * @param data timer data (array)
   * @param date Date
   */
  writeTimers: (data: Timer[], date: Date) => Promise<void>
  /**Delete by timers id */
  deleteTimersById: (id: number) => Promise<void>
  /** Clears all timers from device */
  clearTimers: () => Promise<void>
  /** yyyy-mm-dd as string, flag timecard was generated at some point for these timers.*/
  flagTimecardGenerated: (date: string) => Promise<void>
  /**yyyy-mm-dd as string, deleted timers before a date only if it has been flagged that a timecard exists*/
  deleteFlaggedBeforeDate: (date: string) => Promise<void>
}
export const TimersModel = (): TimersModelReturn => {
  const { run, query } = useDatabase()

  const getTimers = async (): Promise<Timers> => {
    const sql = `
    SELECT * FROM timers WHERE date = date('now', 'localtime');
    `

    return await query(sql)
      .then((timers) => {
        if (timers && timers.length) {
          const data = JSON.parse(timers[0]['timer_data'])
          return data
        } else {
          return []
        }
      })
      .catch((error) => console.log(error))
  }

  const getAll = async () => {
    const sql = `
    SELECT * FROM timers ORDER BY id DESC;
    `

    return await query(sql)
  }

  const getAllTimers = async () => {
    const sql = `
    SELECT * FROM timers ORDER BY id DESC;
    `

    return await query(sql)
      .then((timers) => {
        if (timers) {
          const data = timers.map((daysTimers) => {
            return JSON.parse(daysTimers['timer_data'])
          })
          return data
        } else {
          return []
        }
      })
      .catch((error) => console.log(error))
  }

  const getAllPreviousTimers = async () => {
    const sql = `
    SELECT * FROM timers WHERE date != date('now', 'localtime') ORDER BY id DESC;
    `

    return await query(sql)
      .then((timers) => {
        if (timers && timers.length) {
          const data = timers.map((daysTimers) => {
            return JSON.parse(daysTimers['timer_data'])
          })
          return data
        } else {
          return []
        }
      })
      .catch((error) => console.log(error))
  }

  const writeTimers = async (data: Timers, date: Date): Promise<void> => {
    const formattedDate = jsDateToSqliteDate(date)
    const queryString = `INSERT INTO timers (id, date, timer_data)
        VALUES (
            (SELECT id FROM timers WHERE date = ?),
            ?,
            ?
        )
        ON CONFLICT (id) DO UPDATE SET
        timer_data = excluded.timer_data;`

    const values = [formattedDate, formattedDate, JSON.stringify(data)]

    await run(queryString, values)
  }

  const deleteTimersById = async (id: number) => {
    await query('select * from timers;').then((res) => {
      console.log(res)
    })
    console.log('deleteTimersById id', id)
    const sql = 'DELETE FROM timers WHERE id = ?'
    const values = [id]
    await run(sql, values)
      .catch((error) => console.log(error))
      .then(async () => {
        await query('select * from timers;').then((res) => {
          console.log(res)
        })
      })
  }

  const flagTimecardGenerated = async (date: string) => {
    const sql = `
    UPDATE timers
    SET attributes = '{"timecard_generated": true}'
    where date = ?`

    const value = [date]

    await run(sql, value)
  }
  const clearTimers = async () => {
    const sql = 'DELETE FROM timers'
    await run(sql, []).catch((error) => console.log(`Error deleting timers: ${error}`))
  }

  const deleteFlaggedBeforeDate = async (date: string) => {
    const sql = `
    DELETE FROM timers
    WHERE id IN (
      SELECT id FROM timers WHERE
      date < ?
      AND
      json_extract(attributes, '$.timecard_generated') = true
    );
    `
    const value = [date]

    await run(sql, value)
    console.log(await query('select * from timers'))
  }
  return {
    getAll,
    getTimers,
    getAllTimers,
    getAllPreviousTimers,
    writeTimers,
    deleteTimersById,
    clearTimers,
    flagTimecardGenerated,
    deleteFlaggedBeforeDate,
  }
}
